/* Whitehouse V22 visual-only variant merchandising sync.
   Does not replace Shopify's product form, cart, gallery, checkout or quote controllers. */
(() => {
  'use strict';
  function mount(section) {
    if (!section || section.dataset.whlV22Mounted === '1') return;
    const json = section.querySelector('[data-whl-v20-data]');
    const host = section.querySelector('[data-whl-v22-image-flags]');
    if (!json || !host) return;
    let data;
    try { data=JSON.parse(json.textContent); } catch (_) { return; }
    const variants=new Map((data.variants||[]).map(v=>[String(v.id),v]));
    const initial=host.querySelector('.whl-v22-flag');
    const nonSale=initial?.classList.contains('whl-v22-flag--sale') ? null : (initial ? {label:initial.textContent, css:initial.className} : null);
    function sync() {
      const id=section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value || data.variantId;
      const v=variants.get(String(id));
      if (!v) return;
      const sale=Number(v.compareAt||0)>Number(v.price||0);
      let el=host.querySelector('.whl-v22-flag');
      if (sale) {
        if (!el) {el=document.createElement('span');host.appendChild(el);}
        el.className='whl-v22-flag whl-v22-flag--sale'; el.textContent='Sale';
      } else if(nonSale) {
        if (!el) {el=document.createElement('span');host.appendChild(el);}
        el.className=nonSale.css; el.textContent=nonSale.label;
      } else if(el) el.remove();
    }
    section.dataset.whlV22Mounted='1';
    const input=section.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if(input) new MutationObserver(sync).observe(input,{attributes:true,attributeFilter:['value']});
    section.addEventListener('change',sync);
    section.addEventListener('variant:change',sync);
    section.addEventListener('input',e=>{if(e.target?.name==='id') sync();});
    sync();
  }
  function init(scope=document) {
    if(scope.matches?.('[data-whl-main-product]')) mount(scope);
    scope.querySelectorAll?.('[data-whl-main-product]').forEach(mount);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
